import React, { useEffect, useState } from "react"
import { Rnd } from "react-rnd"
import {
  Button,
  Box,
  Grid,
} from "@mui/material"
import vec1 from "../../assets/modelcheck/bitereg/vec1.svg"
import vec2 from "../../assets/modelcheck/bitereg//vec2.svg"
import vec3 from "../../assets/modelcheck/bitereg//vec3.svg"
import vec4 from "../../assets/modelcheck/bitereg//vec4.svg"
import vec5 from "../../assets/modelcheck/bitereg//vec5.svg"
import vec6 from "../../assets/modelcheck/bitereg//vec6.svg"
import vec7 from "../../assets/modelcheck/bitereg//vec7.svg"
import vec8 from "../../assets/modelcheck/bitereg//vec8.svg"
import vec9 from "../../assets/modelcheck/bitereg//vec9.svg"
import vec10 from "../../assets/modelcheck/bitereg//vec10.svg"

import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { viewControlInTreatment, wasmModule } from "@/gluelayer"
import { debounce } from "lodash"
import { setCurArch, setCurLeftPage } from "@/UDTreat/udTreatSlice"
import { useParams } from "react-router-dom"
import { ReactSVG } from "react-svg"

const UDBiteReg: React.FC = () => {
  const { openBiteReg } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const [dragxy, setDragxy] = useState({ x: 1400, y: 100 })

  const [show3DWidget, setShow3DWidget] = useState(false)

  const dispatch = useAppDispatch()
  const { patientId, caseId } = useParams()
  const { caseDetail } = useAppSelector((state: RootState) => state.caseService)
  const { uassist_round } = caseDetail

  useEffect(() => {
    const handleResize = () => {
      setDragxy({ x: window.innerWidth * 0.75, y: 150 })
    }

    // 初始化设置一次
    handleResize()

    // 监听窗口大小变化
    window.addEventListener("resize", handleResize)

    return () => {
      window.removeEventListener("resize", handleResize)
      if (!wasmModule.isFinishedOpencase) return
      wasmModule.moduleManager.SwitchModuleBiteReg(false)
      dispatch(setCurLeftPage(""))
    }
  }, [])

  useEffect(() => {
    if (!wasmModule.isFinishedOpencase) return
    console.log("openBiteReg", openBiteReg)
    wasmModule.moduleManager.SwitchModuleBiteReg(openBiteReg)
    if (openBiteReg) {
      dispatch(setCurArch("all"))
      viewControlInTreatment.setViewType("front")
      wasmModule.moduleManager.GetModuleBiteReg().Set3DWidgetVisiable(true)
    }
  }, [openBiteReg])

  const ButtonGroups = [
    {
      id: 1,
      icon: <ReactSVG src={vec1} />,
      onclick: () => {
        wasmModule.moduleManager.GetModuleBiteReg().MoveBack()
      },
    },
    {
      id: 2,
      icon: <ReactSVG src={vec2} />,
      onclick: () => {
        wasmModule.moduleManager.GetModuleBiteReg().MoveFront()
      },
    },
    {
      id: 3,
      icon: <ReactSVG src={vec3} />,
      onclick: () => {
        wasmModule.moduleManager.GetModuleBiteReg().RotateXFront()
      },
    },
    {
      id: 4,
      icon: <ReactSVG src={vec4} />,
      onclick: () => {
        wasmModule.moduleManager.GetModuleBiteReg().RotateXBack()
      },
    },
    {
      id: 5,
      icon: <ReactSVG src={vec5} />,
      onclick: () => {
        wasmModule.moduleManager.GetModuleBiteReg().MoveLeft()
      },
    },
    {
      id: 6,
      icon: <ReactSVG src={vec6} />,
      onclick: () => {
        wasmModule.moduleManager.GetModuleBiteReg().MoveRight()
      },
    },

    {
      id: 7,
      icon: <ReactSVG src={vec7} />,
      onclick: () => {
        wasmModule.moduleManager.GetModuleBiteReg().RotateZRight()
      },
    },
    {
      id: 8,
      icon: <ReactSVG src={vec8} />,
      onclick: () => {
        wasmModule.moduleManager.GetModuleBiteReg().RotateZLeft()
      },
    },

    {
      id: 9,
      icon: <ReactSVG src={vec9} />,
      onclick: () => {
        wasmModule.moduleManager.GetModuleBiteReg().MoveUp()
      },
    },

    {
      id: 10,
      icon: <ReactSVG src={vec10} />,
      onclick: () => {
        wasmModule.moduleManager.GetModuleBiteReg().MoveDown()
      },
    },
  ]

  const handleDebouncedClick = () => {
    console.log("Button debouncedClick!")
    // 执行其他操作
  }
  const debouncedClick = debounce(handleDebouncedClick, 500) // 设置延迟时间为500毫秒
  return (
    <Rnd
      position={{ x: dragxy.x, y: dragxy.y }}
      onDragStop={(e, d) => {
        setDragxy({ x: d.x, y: d.y })
      }}
      dragHandleClassName="dragarea"
    >
      <Box
        className="dragarea"
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          width: 155,
          height: 263,
          borderRadius: "6px",
          backgroundColor:"rgba(255, 255, 255, 0.5)",
          boxShadow:
            "0 8px 12px 6px rgba(0, 0, 0, 0.15), 0 4px 4px 0 rgba(0, 0, 0, 0.30)",
        }}
      >
        <Grid container columnGap={1} rowGap={2} justifyContent="center">
          {ButtonGroups.map((item) => (
            <Grid item key={item.id}>
              <Button
                variant="outlined"
                onClick={() => {
                  item.onclick()
                  debouncedClick()
                }}
                sx={{
                  width: 63,
                  height: 30,
                  backgroundColor: "#F0F0F0",
                  borderRadius: "3px",
                  boxShadow:
                    "0 1px 2px 0 rgba(0,0,0,0.30), 0 1px 3px 1px rgba(0,0,0,0.15)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingTop: "12px",
                }}
              >
                {item.icon}
              </Button>
            </Grid>
          ))}
        </Grid>
      </Box>
    </Rnd>
  )
}

export default UDBiteReg
